module.exports = __webpack_public_path__ + "img/logo.fc02fef3.png";